import { node } from 'prop-types';

import AuthFormCol from './column';
import AuthFormRow from './row';

function AuthFormTitle({ children }) {
  return (
    <AuthFormRow>
      <AuthFormCol>
        <h3 className="AuthFormTitle">{children}</h3>
      </AuthFormCol>
    </AuthFormRow>
  );
}

AuthFormTitle.propTypes = {
  children: node,
};

export default AuthFormTitle;
